import React from "react";

const AnchorID = ({id, offset}) => (
  <div id={id} className="anchorID" style={{top: offset}}/>
)

export default AnchorID;